import '@babel/polyfill';

// Suppress warnings
const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;

console.error = (...args) => {
  const message = args.join(' ');
  if (
    // TODO-ZEN-804 Suppress findDOMNode deprecation warnings from external dependencies (landscape Popover)
    message.includes('findDOMNode is deprecated') ||
    // TODO-ZEN-804 Suppress generic React prop type warnings.
    (/Failed prop type: Invalid prop/).test(message) ||
    (/Invalid prop .* supplied to/).test(message) ||
    // TODO-ZEN-804 Suppress legacy context API warnings from external dependencies (landscape TransitionGroup)
    message.includes('uses the legacy childContextTypes') ||
    message.includes('unmountComponentAtNode is deprecated') ||
    // camlough-react-wordcloud defaultProps (see ZEN-2416 comment)
    (message.includes('Support for defaultProps') && args.some(a => String(a) === 'Wordcloud'))
  ) {
    return;
  }
  originalConsoleError(...args);
};

console.warn = (...args) => {
  const message = args.join(' ');
  if (
    // TODO-ZEN-804 Suppress legacy context API warnings from external dependencies (landscape TransitionGroup)
    message.includes('uses the legacy childContextTypes')
  ) {
    return;
  }
  originalConsoleWarn(...args);
};

import React, { useEffect, useReducer } from 'react';
import { createRoot } from 'react-dom/client';

import { createStore } from './store';
import { Provider } from 'react-redux';
import OktaSignIn from '@okta/okta-signin-widget';
import { OktaAuth } from '@okta/okta-auth-js';
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';
import './indexLogin.css';

import { browserHistory, Router, Route } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

import theme from './theme';

// Import landscape components here.
import ThemeProvider from 'zignal-landscape/lib/ThemeProvider';
import Loading from 'zignal-landscape/lib/Loading';

import Login from 'containers/Login';
import apiClient from 'helpers/apiClient';
import { ErrorBoundary } from 'components';

let store;
if (process.env.NODE_ENV === 'development') {
  store = createStore(browserHistory,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
} else {
  store = createStore(browserHistory, window.__data);
}

const history = syncHistoryWithStore(browserHistory, store);
const dest = document.getElementById('root');

const LoginWithMessage = (props) => {
  const initialState = {
    loading: true,
    oktaConfig: {}
  };

  const oktaConfigReducer = (state, action) => {
    if (action.type === 'populateConfig') {
      return {
        ...state,
        loading: false,
        oktaConfig: action.payload
      };
    }
    return initialState;
  };

  const [state, dispatch] = useReducer(oktaConfigReducer, initialState);
  const {
    loading,
    oktaConfig
  } = state;

  useEffect(() => {
    const fetchSession = async () => {
      const config = await apiClient('/auth/okta_ui_config');
      const authConfig = {
        ...config.oidc.authParams,
        clientId: config.oidc.clientId,
        redirectUri: `${window.location.origin}/login`
      };
      const oktaAuth = new OktaAuth(authConfig);
      const sessionExists = await oktaAuth.session.exists();
      if (sessionExists) {
        const currentSession = await oktaAuth.session.get();
        const response = await oktaAuth.token.getWithoutPrompt({
          responseType: ['id_token', 'token', 'refresh_token']
        });
        const refreshToken = response.tokens.refreshToken.refreshToken;
        apiClient('/auth/okta_session', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${response.tokens.accessToken.accessToken}`,
          },
          body: JSON.stringify({
            username: currentSession.login,
            refreshToken
          })
        }).then(() => {
          window.location.pathname = '/home';
        });
      } else {
        dispatch({ type: 'populateConfig', payload: config });
      }
    };

    fetchSession()
      .catch(console.error);
  }, []);

  return (
    <React.Fragment>
      {
        loading === false ?
          <Login
            {...props}
            isOktaLogin
            OktaSignIn={OktaSignIn}
            oktaConfig={oktaConfig}
          />
          : <Loading />
      }
    </React.Fragment>
  );
};

const routerComponent = (
  <Router history={history}>
    <Route path="*" component={LoginWithMessage} />
  </Router>
);

const root = createRoot(dest);
root.render(
  <ErrorBoundary>
    <Provider store={store} key="provider">
      <ThemeProvider theme={theme}>
        {routerComponent}
      </ThemeProvider>
    </Provider>
  </ErrorBoundary>
);
